import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Paper, Box } from '@material-ui/core'
import { connect } from 'react-redux'
import { ReduxStore } from '../../stores';
import MuiTheme from '../../MuiTheme';
import { Chapter } from './@types';
import FormDialog from '../../Components/FormDialog';
import { TextValidator } from 'react-material-ui-form-validator'
import KeywordsForm from '../../Components/KeywordsForm';
import { OChapter } from './Model';
import { RouteComponentProps, withRouter } from 'react-router';
import { ThunkDispatch } from 'redux-thunk';
import { TAction } from 'loop-front';
import { AxiosPromise } from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import PictureInput from 'Components/Input/PictureInput';
import { TINY_API_KEY } from 'Resources/Config';

interface IStateProps { }

interface IDispatchProps {
    submitForm: (FormData: Partial<Chapter>) => AxiosPromise
}

interface IState {
    showForm: boolean
    keywordField: string
    formData: Partial<Chapter>
    submittingForm: boolean
}

interface OwnProps {
    open: boolean
    chapter?: Chapter
    onClose?: () => void
}

interface IProps extends WithStyles<typeof STYLES>, RouteComponentProps<{ bookId: string }>, IStateProps, IDispatchProps, OwnProps {

}

class Form extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        let bookId = this.props.match.params['bookId'];
        bookId || console.log('bookId not received', this.props.match);
        this.state = {
            showForm: this.props.open,
            keywordField: '',
            submittingForm: false,
            formData: {
                name: '',
                description: '',
                shortDescription: '',
                keywords: [],
                number: 0,
                bookId: this.props.match.params['bookId'],
                _coverPicture: undefined
            }
        }
    }

    componentDidMount() {
        const { chapter = undefined } = this.props;
        if (this.props.chapter) {
            this.setState({ formData: { ...this.state.formData, ...chapter } });
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            formData: { ...this.state.formData, [e.target['name']]: e.target['value'] }
        })
    }

    handleSubmit = async () => {
        console.log('Submitted Form Data', this.state.formData);
        this.setState({ submittingForm: true });
        const res = await this.props.submitForm(this.state.formData).catch((error) => this.setState({ submittingForm: false }));
        if (res) {
            this.handleClose();
        }
        this.setState({ submittingForm: false });
    }

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.setState({ showForm: false });
    }

    render() {
        const { classes } = this.props
        const { formData, submittingForm = false } = this.state
        return (
            <div>
                <FormDialog
                    open={this.state.showForm}
                    onCloseButtonClick={this.handleClose}
                    title={'Add New Chapter'}
                    onSubmit={this.handleSubmit}
                    loading={submittingForm}
                    dialog={false}
                >
                    <Paper className={classes.formPaper} >
                        <TextValidator
                            type='number'
                            placeholder='Chapter Number'
                            fullWidth
                            name='number'
                            value={formData.number || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            validators={['required', 'isPositive']}
                            errorMessages={['This field is required', 'Only positive numbers are allowed']}
                        />
                        <PictureInput
                            enableReinitialization
                            withCropping
                            cropConfig={{ aspect: 16 / 9 }}
                            initialPicture={formData?._coverPicture}
                            onPicUpload={coverPicture => this.setState({ formData: { ...formData, '_coverPicture': coverPicture } })}
                            onPictureRemove={() => this.setState({ formData: { ...formData, '_coverPicture': undefined } })}
                        />
                        <TextValidator
                            placeholder='Chapter Name'
                            fullWidth
                            name='name'
                            value={formData.name || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            className={classes.inputFieldHeight}
                            validators={['required']}
                            errorMessages={['This field is required']}
                        />
                        <TextValidator
                            placeholder='Short Description'
                            fullWidth
                            name='shortDescription'
                            value={formData.shortDescription || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            multiline
                            errorMessages={['This field is required']}
                            className={classes.inputField}
                        />
                        <Box border={'1px Solid'} >
                            <Editor
                                apiKey={TINY_API_KEY}
                                init={{
                                    minHeight: '200px !important',
                                    toolbar: 'bold link italic code undo redo',
                                    plugins: ['link'],
                                    min_height: 200,
                                }}
                                initialValue={formData.description || ''}
                                onChange={e => { this.setState({ formData: { ...formData, description: e.target.getContent() } }) }}
                            />
                        </Box>
                        <KeywordsForm enableReinitialization initialKeywords={formData.keywords} onKeywordsUpdate={(keywords) => this.setState({ formData: { ...this.state.formData, keywords } })} />
                    </Paper>
                </FormDialog>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({

})

const mapDispatchToProps = (dispatch: ThunkDispatch<ReduxStore, {}, TAction>): IDispatchProps => ({
    submitForm: (formData: Partial<Chapter>) => dispatch(formData.id ? OChapter.putItem(formData) : OChapter.postItem(formData))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    formPaper: {
        boxSizing: 'border-box',
        width: 650,
        padding: 50,
        '& > div': {
            marginBottom: 20,
        },
    },
    inputField: {
        marginTop: 25
    },
    inputFieldHeight: {
        height: 48,
        marginTop: 25
    },
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Form)))